<template>
  <div id="know">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>培训考试&nbsp;/&nbsp;知识管理</span>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="知识列表" name="first">
          <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS' v-if="clearId"></Provinces>
           <el-input class="elinputs" v-model="beginData.title" placeholder="知识标题"></el-input>
           <el-input class="elinputs" v-model="beginData.label" placeholder="标签"></el-input>
           <!-- <el-input class="elinputs" v-model="beginData.id" placeholder=" 搜索编号"></el-input> -->
            <el-select v-model="beginData.cid" placeholder="所属分类" class="elinputs">
                <el-option v-for="item in cidList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="beginData.isshow" placeholder="是否显示" class="elinputs">
                <el-option v-for="item in beginData.isShows" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="beginData.istop" placeholder="是否置顶" class="elinputs">
                <el-option v-for="item in beginData.isTops" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click="reset">重置</el-button>
          </div>
          <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
          </div>
          <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <!-- <el-table-column prop="id" label="编号" width="100"></el-table-column> -->
            <el-table-column prop="title" label="知识标题" width="240"></el-table-column>
            <el-table-column min-width="110" label="缩略图">
              <template slot-scope="scope">
                <viewer>
                  <img class="sfzimg" :src="imgUrl+scope.row.coverImage" />
                </viewer>
              </template>
            </el-table-column>
            <el-table-column prop="label" label="标签" width="160"></el-table-column>
            <el-table-column prop="cname" label="所属分类" width="160"></el-table-column>
            <el-table-column prop="areasName" label="所属地区" width="160"></el-table-column>
            <el-table-column prop="readFalse" sortable label="浏览次数（假）" width="180"></el-table-column>
            <el-table-column prop="readTrue" sortable label="浏览次数（真）" width="180"></el-table-column>
            <el-table-column label="是否显示" width="130">
              <template slot-scope="scope">
                  <p class="boldfont" v-if="scope.row.isshow==0">是</p><p class="boldfont" v-if="scope.row.isshow==1" style="color:#F56C6C">否</p>
              </template>
            </el-table-column>
            <el-table-column label="是否置顶" width="130">
              <template slot-scope="scope">
                  <p class="boldfont" v-if="scope.row.istop==0">是</p><p class="boldfont" v-if="scope.row.istop==1" style="color:#F56C6C">否</p>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" sortable label="添加时间" min-width="180"></el-table-column>
            <el-table-column prop="modifyTime" sortable label="修改时间" min-width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" min-width="180">
              <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(2,scope.row,'know:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'know:delete')"><i class="el-icon-delete"></i> 删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="知识分类" name="second">
          <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSSF' v-if="clearId"></Provinces>
           <el-input class="elinputs" v-model="beginData.cname" placeholder="分类名称"></el-input>
           <!-- <el-input class="elinputs" v-model="beginData.ccode" placeholder=" 搜索编号"></el-input> -->
            <el-select v-model="beginData.isshow" placeholder="是否显示" class="elinputs">
                <el-option v-for="item in beginData.isShows" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click="reset">重置</el-button>
          </div>
          <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
          </div>
          <el-table :data="tableData2" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="name" label="分类名称" width="120"></el-table-column>
            <el-table-column prop="areasName" label="所属地区" width="120"></el-table-column>
            <el-table-column min-width="120" label=" 图标">
              <template slot-scope="scope">
                <viewer>
                  <img class="sfzimg" :src="imgUrl+scope.row.icon" />
                </viewer>
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" width="120"></el-table-column>
            <el-table-column label="是否显示" sortable min-width="80">
              <template slot-scope="scope">
                  <p class="boldfont" v-if="scope.row.cisshow==0">是</p><p class="boldfont" v-if="scope.row.cisshow==1" style="color:#F56C6C">否</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="180">
              <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(2,scope.row,'know:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'know:delete')"><i class="el-icon-delete"></i> 删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class="paging">
        <span>
          共
          <i class="pagingNum">{{total}}</i> 条
        </span>
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog title="添加/编辑文章" :visible.sync="dialogFormVisible" @close="dataClose" width="60%">
        <el-form v-if="activeName == 'first'">
            <el-form-item label="* 所属分类：">
                <el-select v-model="details.cname" placeholder="请选择所属分类" @change="ckcId">
                    <el-option
                    v-for="item in cidList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 所属地区：">
                <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                    <el-option
                    v-for="item in shenglist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="shi" placeholder="城市" @change="ckshi" class="cty16">
                    <el-option
                    v-for="item in shilist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 文章标题：">
               <el-input placeholder="请输入文章标题" v-model="details.title" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 缩略图：" style='margin-bottom: 10px;'>
                <el-upload
                    class="upload-demo"
                    :action="URL"
                    :limit="1"
                    :on-remove="handleRemove"
                    :on-success="handleAvatarSuccess"
                    :data="newobj"
                    :file-list="details.cover"
                    name="multipartFile"
                    :headers="newhead"
                    list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">选择缩略图，推荐尺寸600*600px，大小100k以内</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="* 标 签：">
                <!-- <el-button size="small" @click="innerVisible = true" type="primary">点击添加</el-button> -->
                <!-- <div class="el-upload__tip">最多只能添加5个标签</div> -->
                <div>
                  <el-tag :key="tag" v-for="tag in details.labels" closable :disable-transitions="false" @close="handleClose(tag)">{{tag}}</el-tag>
                 <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"></el-input>
                  <el-button v-else class="button-new-tag" size="small" @click="showInput">添加标签(字数不能超过5个字)</el-button><i class="tx">最多只能添加3个标签</i>
                </div>
            </el-form-item>
            <el-form-item label="* 详细内容：" style="align-items: end;margin-top:16px">
                <editor-bar v-model="details.content" :isClear="isClear" @change="change" style="margin: 0; width: inherit;"></editor-bar>
            </el-form-item>
            <!-- <div style='min-height: 340px;'>
              <editor-bar v-model="details.content" :isClear="isClear" @change="change"></editor-bar>
            </div> -->
            <el-form-item label="* 浏览量（假）：">
               <el-input placeholder="浏览量（假）" v-model="details.readFalse" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 排 序：">
               <el-input placeholder="数字越大，排名越靠前（请输入正整数）" v-model="details.sort" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 是否显示：">
                <el-radio v-model="details.isshow" label=0>是</el-radio>
                <el-radio v-model="details.isshow" label=1>否</el-radio>
            </el-form-item>
            <el-form-item label="* 是否置顶：">
                <el-radio v-model="details.istop" label=0>是</el-radio>
                <el-radio v-model="details.istop" label=1>否</el-radio>
            </el-form-item>
        </el-form>
        <el-form v-else>
            <el-form-item label="* 分类名称：">
               <el-input placeholder="请输入分类名称" v-model="details.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 图标" style='margin-bottom: 10px;'>
                <el-upload
                    class="upload-demo"
                    :action="URL"
                    :limit="1"
                    :on-remove="handleRemove"
                    :on-success="handleAvatarSuccess"
                    :data="newobj"
                    ref="upload"
                    :file-list="details.cover"
                    name="multipartFile"
                    :headers="newhead"
                    list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip"> 选择图标，推荐尺寸600*600px，大小100k以内</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="* 所属地区：">
                <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                    <el-option
                    v-for="item in shenglist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="shi" placeholder="城市" @change="ckshi" class="cty16">
                    <el-option
                    v-for="item in shilist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 排 序：">
               <el-input placeholder="数字越大，排名越靠前（请输入正整数）" v-model="details.sort" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 是否显示：">
                <el-radio v-model="details.cisshow" label=0>是</el-radio>
                <el-radio v-model="details.cisshow" label=1>否</el-radio>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="puton">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext'
import Reset from "@/components/Reset";
import Paging from '@/components/Paging';
import Provinces from "@/components/Provinces";
export default {
  name: "know",
  components: {
    Xlsx,
    EditorBar,
    Reset,
    Paging,
    Provinces
  },
  data() {
    return {
      beginData:{isShows:[{id:0,name:'是'},{id:1,name:'否'}],isTops:[{id:0,name:'是'},{id:1,name:'否'}]},
      tableData: [],
      tableData2:[],
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      innerVisible: false,
      details: {labels:[],isshow:'0',istop:'0',cisshow:'0'},
      userdata: {},
      total: 0,
      btn: [],
      fullscreenLoading: true,
      imgurl:'',
      imgUrl: this.$Public.imgUrl,
      formname:JSON.stringify({name:'知识管理',hint:'know:export'}),
      cid:'',
      cidList:[],
      URL:`${this.$Public.URL}/api-r/upload/uploadImg`,
      newobj:{type:2},
      newhead:{
            accessToken:JSON.parse(sessionStorage.getItem('userdata')).token
      },
      fileList2:[],
      inputVisible: false,
      inputValue: '',
      isClear: false,
      sheng:'',
      shengName: '',
      shi:'',
      shenglist:[],
      shilist:[],
      status:'',
      activeName: 'first',
      multipleSelection:[],
      beginIdfl:'',
      classId:'',
      clearId:true
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    let userdata = JSON.parse(sessionStorage.getItem("userdata"));
    this.$set(this, "userdata", userdata);
    this.beginIdfl = userdata.areasId;
    this.classId = userdata.areasId;
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  watch:{
    tableData2(newV){
      // console.log(123321)
    }
  },
  mounted() {
    // 查询下拉框分类
    let data = this.$qs.stringify({
        areasId:this.userdata.areasId
    })
    this.$axios.post(`/api-e/category/categoryA`, data, {headers: { accessToken: this.userdata.token }})
    .then(res => {
        if(res.data.success){
            this.cidList = res.data.categoryInfoList
        }
    });
    let region = JSON.parse(localStorage.getItem('region'))
    region.forEach(x => {
        if(x.level==0){
            this.shenglist.push(x);
            this.sheng=x.id;
            this.shengName=x.name;
        }
    });
    if(this.userdata.level==0){
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:region[0].id}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.$set(this,'shilist',res.data.areaListInfoList)
            }
        })
    }else{
        region.forEach(x=>{
            if(x.level==1){
                this.shilist.push(x);
                this.shi=x.id;
                this.details.areasid = this.sheng +','+ x.id;
                this.details.areasName = this.shengName +','+ x.name;
            }
        })
    }
  },
  methods: {
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('know:add')==-1){
                return this.$message.error('抱歉，用户暂无该权限')
            }
            this.handleEdit(1)
        }else if(i==2){
            if(this.btn.indexOf('know:update')==-1){
                return this.$message.error('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message.error('请勾选一项内容编辑')
            }
            this.handleEdit(2,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('know:delete')==-1){
                return this.$message.error('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message.error('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            if(this.activeName == 'first'){
              url = `/api-e/article/deleteArticle/${arr.join(',')}`
            }else{
              url = `/api-e/category/deleteCategory/${arr.join(',')}`
            }
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    handleClick(tab, event) {
      if(this.activeName == 'first'){
        this.begin()
      }else{
        this.classify()
      }
    },
    // 获取省市传入的id
    gainSS(i){
        this.beginIdfl = i.id
    },
    gainSSF(i){
        this.classId = i.id
    },
    // 知识分类列表获取
    classify(){
      let data2 = this.$qs.stringify({
          areasId:this.classId,
          pageNum:this.pageNum,
          pageSize:this.pageSize,
          ccode:this.beginData.ccode,
          cname:this.beginData.cname,
          isShow:this.beginData.isShow,
      })
      this.$axios.post(`/api-e/category/categoryListA`, data2, {headers: { accessToken: this.userdata.token }})
      .then(res => {
        this.fullscreenLoading = false;
        if(res.data.success){
            this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
              // this.tableData2 = res.data.pageInfo.list
              this.$set(this,'tableData2',res.data.pageInfo.list)

              this.$forceUpdate()
            });
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
                type: 'success',
                message: res.data.msg
            });
        }
      });
    },
    // 关闭清空内容
    dataClose(){
      this.shi=''
      this.details = {labels:[],isshow:'0',istop:'0',cisshow:'0',cover:[]}
    },
    change(val) {
      console.log(val)
    },
    // 提交
    puton(){
      if(this.details.areasid == undefined || this.details.areasid == ''){
        return this.$message.error('请选择所属地区')
      }


      let url = ''
      if(this.activeName == 'first'){

        this.details.coverImage = this.fileList2.join(',')
        const label = this.details.labels.join(',')
        this.details.label = label

        // 判断是否填写完成内容
      if (
          !this.details.title ||
          !this.details.coverImage ||
          !this.details.labels || this.details.labels.length == 0 ||
          !this.details.content ||
          !this.details.readFalse ||
          !this.details.sort
        ) {
          return this.$message.error("请完善内容填写");
        }

        if(this.status == 1){
            url = `/api-e/article/addArticle`
        }else if(this.status == 2){
            url = `/api-e/article/updateArticle`
        }
      }else{
        this.details.icon = this.fileList2.join(',')

        // 判断是否填写完成内容
      if (
          !this.details.name ||
          !this.details.icon ||
          !this.details.sort
        ) {
          return this.$message.error("请完善内容填写");
        }

        if(this.status == 1){
            url = `/api-e/category/addArticleCategory`
        }else if(this.status == 2){
            url = `/api-e/category/updateCategory`
        }
      }
      this.fullscreenLoading = true;
      this.$axios.post(url, this.$qs.stringify(this.details), {headers: { accessToken: this.userdata.token }})
      .then(res=>{
        this.dialogFormVisible = false;
        if(this.status == 1){
            this.begin();
        }else if(this.status == 2){
            this.classify()
        }
      })
    },
    // 所属分类ID
    ckcId(val){
        this.details.cid = val;
    },
    // 地区id
    cksheng(val){
        this.$set(this,'shi','')
    },
    ckshi(val){
        this.details.areasid = this.sheng +','+ val
        let addName = ''
        this.shilist.forEach(x=>{
          if(val == x.id){
            addName = x.name
          }
        })
        this.details.areasName = this.shenglist[0].name +','+ addName
    },
    // 点击添加标签
    handleClose(tag) {
      this.details.labels.splice(this.details.labels.indexOf(tag), 1);
    },
    showInput() {
      if(this.details.labels.length>2){
        return this.$message.error('最多添加3个标签')
      }
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.details.labels.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    // 略缩图处理
    handleRemove(file, fileList) {
        if(fileList.length>0){
            let newarr = []
            fileList.forEach(x => {
                newarr.push(x.response.url)
            });
            this.fileList2 = newarr
        }else{
            this.fileList2 = []
        }
    },
    handleAvatarSuccess(res, file) {
        this.fileList2.push(res.url)
    },
    reset() {
      this.beginData = {isShows:[{id:0,name:'是'},{id:1,name:'否'}],isTops:[{id:0,name:'是'},{id:1,name:'否'}]}
      this.clearId = false
      this.$nextTick( function () {
          this.clearId = true
      })
      if(this.activeName == 'first'){
        this.beginIdfl = this.userdata.areasId
        this.begin();
      }else{
        this.classId = this.userdata.areasId
        this.classify();
      }
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin();
    },
    begin() {
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id:this.beginData.id,
        cid:this.beginData.cid,
        isshow:this.beginData.isshow,
        istop:this.beginData.istop,
        label:this.beginData.label,
        title:this.beginData.title,
        areasid: this.beginIdfl,
      });
      this.$axios
        .post(`/api-e/article/articleLists`, data, {
          headers: { accessToken: this.userdata.token }
        })
        .then(res => {
          this.fullscreenLoading = false;
          if(res.data.success){
            // this.$set(this, "tableData", res.data.pageInfo.list);

            this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
              this.$set(this, "tableData", res.data.pageInfo.list);
            });
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
                type: 'success',
                message: res.data.msg
            });
          }else{
            this.$message(res.data.msg)
          }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message.error('抱歉，用户暂无该权限')
        }
      this.status = i
      this.fileList2 = []
      if(i == 2){
        if(this.activeName == 'first'){
          this.$axios.post(`/api-e/article/getArticle/${row.id}`,{},{ headers: { accessToken: this.userdata.token } })
          .then(res => {
            res.data.isshow +=''
            res.data.istop +=''
            this.fileList2.push(res.data.coverImage)
            res.data.cover = [{name:'略缩图',url:`${this.imgUrl+res.data.coverImage}`}]
            res.data.labels = res.data.label.split(',')
            this.sheng = Number(res.data.areasid.split(',')[0])
            this.shi = Number(res.data.areasid.split(',')[1])
            this.$set(this, "details", res.data);
          });
        }else{
          this.$axios.post(`/api-e/category/getCategoryById/${row.id}`,{},{headers: { accessToken: this.userdata.token } })
          .then(res => {
            res.data.cisshow +=''
            this.fileList2.push(res.data.icon)
            res.data.cover = [{name:'略缩图',url:`${this.imgUrl+res.data.icon}`}]
            this.sheng = Number(res.data.areasid.split(',')[0])
            this.shi = Number(res.data.areasid.split(',')[1])
            this.$set(this, "details", res.data);
          });
        }

      }
      this.dialogFormVisible = true;
    },
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message.error('抱歉，用户暂无该权限')
        }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          if(this.activeName == 'first'){
            url = `/api-e/article/deleteArticle/${row.id}`
          }else{
            url = `/api-e/category/deleteCategory/${row.id}`
          }
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  if(this.activeName == 'first'){
                    this.begin();
                  }else{
                    this.classify();
                  }
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      if(this.activeName == 'first'){
        this.begin();
      }else{
        this.classify();
      }
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
/* #know .editor{
    width: 84%;
} */
#know .el-input__inner {
  margin: 10px 0;
}
#know .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#know .el-menu-item.is-active{
  background: none
}
#know .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#know .el-tag{
  margin-right: 12px;
}
#know .el-select {
  /* margin: 0 8px; */
    width: 100%;
}
#know .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#know .el-upload-list--picture .el-upload-list__item {
    width: 44%;
    float: left;
    margin-right: 2%;
}
#know .el-form-item__content {
    width: 100%;
}
#know .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#know .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#know .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#know .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#know .el-dialog__body {
  height: 382px;
}
#nei .el-dialog__body{
  height: 150px !important;
}
#know .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#know .el-form-item__content {
    width: 100%;
    display: flex;
    align-items: center;
}
#know .el-form-item__label{
    width: 160px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
</style>
